import {Models} from "@rematch/core";
import COSOrders from "./models/COSOrdersModel";
import {iWebRootModelIndex, webRootModels} from "fulogics-ui-web/dist/store/iWebRootModel";
import Settings from "./models/Settings";
import COSOrderForwardStepCollection from "./models/COSOrderForwardStepCollectionModel";
import COSOrderForwardStep from "./models/COSOrderForwardStepModel";
import ForwardStepDestinationLocations from './models/ForwardStepDestinationLocationsModel'
import COSOrderForwardStepPayload from "./models/COSOrderForwardStepPayloadModel";
import Warehouse from "./models/WarehouseModel";
import ProductInfo from "./models/ProductInfoModel";
import COSOrderReturnStep from "./models/COSOrderReturnStepModel";
import COSOrderReturnStepPayload from "./models/COSOrderReturnStepPayloadModel";
import ReturnStepOriginLocations from "./models/ReturnStepOriginLocationsModel"

// @ts-ignore
export interface iRootModel extends iWebRootModelIndex, Models<iRootModel> {
    COSOrders: typeof COSOrders
    //
    COSOrderForwardStep: typeof COSOrderForwardStep
    COSOrderForwardStepCollection: typeof COSOrderForwardStepCollection
    COSOrderForwardStepPayload : typeof COSOrderForwardStepPayload,
    //
    COSOrderReturnStep : typeof COSOrderReturnStep,
    COSOrderReturnStepPayload : typeof COSOrderReturnStepPayload,
    //
    ForwardStepDestinationLocations: typeof ForwardStepDestinationLocations
    ReturnStepOriginLocations : typeof ReturnStepOriginLocations,
    //
    ProductInfo: typeof ProductInfo,
    Warehouse : typeof Warehouse,
    //
    Settings: typeof Settings
}

// @ts-ignore
export const rootModels: iRootModel = {
    COSOrders,
    //
    COSOrderForwardStep,
    COSOrderForwardStepCollection,
    COSOrderForwardStepPayload,
    //
    COSOrderReturnStep,
    COSOrderReturnStepPayload,
    //
    ForwardStepDestinationLocations,
    ReturnStepOriginLocations,
    //
    Warehouse,
    ProductInfo,
    //
    Settings,
    //
    ...webRootModels,
}